<script setup>
import { onMounted, ref, watchEffect } from 'vue'
import { AutoCompleteDropdown, DmTag } from 'dmui_components'
import OrgRepository from '../repository/OrgRepository.js'

const props = defineProps({
	selectedOrg: {
		type: Object,
		default: undefined
	}
})
const emit = defineEmits(['update:selectedOrg'])

const organizations = ref([])
const MIN_CHARS_TO_SEARCH = 2

const filter = ref('')
watchEffect(async () => {
	if (filter.value?.length >= MIN_CHARS_TO_SEARCH) {
		organizations.value = await OrgRepository.fetchOrgsFromApi(filter.value)
	}
})

onMounted(async () => {
	if (props.selectedOrg?.org_id) {
		const org = await OrgRepository.fetchOrgById(props.selectedOrg?.org_id)
		organizations.value = [org]
		emit('update:selectedOrg', org)
	}
})
</script>

<template>
	<AutoCompleteDropdown
		id="report-org-name"
		v-model:filter="filter"
		:data="selectedOrg"
		:placeholder="`Type atleast ${MIN_CHARS_TO_SEARCH} characters to see options...`"
		:options="organizations"
		@update:data="$emit('update:selectedOrg', $event)">
		<template #default="{ data }">
			<div class="org-name">
				<DmTag v-if="data.org_type" class="info">{{ data.org_type }}</DmTag>
				<span class="primary-text">{{ data.org_name }}</span>
			</div>
		</template>
	</AutoCompleteDropdown>
</template>
<style scoped lang="less">
.org-name {
	display: flex;
	gap: @micro;
}
</style>
